<template>
	<div :class="{
		'window-view': 	true,
		shake: 			shaking
	}" :style="{ width: `${width}px`, marginLeft: `-${width / 2}px` }">
		<div class="shield" v-show="loading"></div>
		<div class="header">
			<div class="title">{{ title }}</div>
			<div class="corner">
				<svg-icon :class="{
					icon: 		true,
					close:		icon == 'cross',
					loading: 	loading
				}" :icon="icon" @click.stop="iconClick" />
				<half-circle-spinner :class="{
					loader: 	true,
					loading: 	loading
				}" :animation-duration="1000" :size="20" color="#ff5723" />
			</div>
		</div>
		<div :class="{
				body:		true,
				loading: 	loading
			}">
			<slot />
		</div>
		<div :class="{
				footer:		true,
				loading: 	loading
			}">
			<button-view class="action" v-bind="a" v-for="(a, i) in actions" :key="i" @click.stop="action(a.action)">{{ a.label }}</button-view>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				loading:	false,
				shaking: 	false
			};
		},
		props: {
			icon: {
				type: String,
				default: 'cross'
			},
			title: {
				type: String,
				required: true
			},
			actions: {
				type: Array,
				required: true
			},
			cancel: {
				type: Function,
				default() {
					return true;
				}
			},
			width: {
				type: Number,
				default: 600
			}
		},
		methods: {
			async iconClick() {
				if (!this.loading && this.icon == 'cross' && await this.cancel()) {
					this.$emit('pop');
				}
			},
			async action(action) {
				this.loading = true;

				if (await action()) {
					this.$emit('pop');
				} else {
					this.shake();
				}

				this.loading = false;
			},
			shake() {
				var self = this;

				this.shaking = true;

				setTimeout(() => {
					self.shaking = false;
				}, 1000);
			}
		},
		created() {
			console.log('window created', this.$attrs);
		}
	}
</script>

<style lang="scss" scoped>
	.window-view {
		position: absolute;
		background-color: white;
		font-family: Roboto;
		font-weight: 300;
		font-size: 16px;
		letter-spacing: 0.15px;
		color: rgb(128, 128, 128);
		border-radius: 5px;
		min-width: 300px;
		top: 100px;
		left: 50%;

		& > .header {
			display: grid;
			grid-template-columns: 1fr 20px;

			padding: 20px;

			& > .title {
				color: black;
				line-height: 20px;
				letter-spacing: 1px;
				font-weight: 400;
			}

			& > .corner {
				& > .icon {
					width: 20px;
					height: 20px;
					fill: rgb(190, 190, 190);
					transition: 300ms fill linear, 250ms opacity ease-in-out, 250ms transform ease-in-out;
					opacity: 1;
					transform: scale(1);

					&.close {
						cursor: pointer;

						&:hover {
							fill: black;
						}
					}

					&.loading {
						opacity: 0;
						transform: scale(0.5);
					}
				}

				& > .loader {
					opacity: 0;
					transform: scale(0.5);
					transition: 250ms opacity ease-in-out, 250ms transform ease-in-out;
					pointer-events: none;

					&.loading {
						opacity: 1;
						transform: scale(1);
					}
				}

				& > * {
					position: absolute;
				}
			}
		}

		& > .body {
			padding: 0 20px 0 20px;
			font-size: 14px;
			line-height: 20px;
			transition: 300ms opacity ease-in-out;

			&.loading {
				opacity: 0.5;
			}
		}

		& > .footer {
			position: relative;
			padding: 20px;
			text-align: right;
			transition: 300ms opacity ease-in-out;

			&.loading {
				opacity: 0.5;
			}
		}

		& > .shield {
			z-index: 10000;
			position: absolute;
			left: 0;
			top: 0;
			width: 100%;
			height: 100%;
		}
	}

	.shake {
		animation: shake 0.5s cubic-bezier(.36,.07,.19,.97) both;
		transform: translate3d(0, 0, 0);
	}

	@keyframes shake {
		10%, 90% {
			transform: translate3d(-2px, 0, 0);
		}
		20%, 80% {
			transform: translate3d(4px, 0, 0);
		}
		30%, 50%, 70% {
			transform: translate3d(-8px, 0, 0);
		}
		40%, 60% {
			transform: translate3d(8px, 0, 0);
		}
	}
</style>